import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSE = function FlagSE() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#FFDA44",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M19.566 21.74H49.79C48.191 9.472 37.703 0 25.001 0c-1.867 0-3.685.206-5.435.594V21.74ZM13.043 21.74V3.04C6.18 6.785 1.265 13.656.213 21.74h12.832ZM13.043 28.26H.212c1.053 8.084 5.967 14.954 12.832 18.7v-18.7ZM19.566 28.26v21.146c1.75.387 3.568.594 5.435.594 12.702 0 23.19-9.473 24.788-21.74H19.566Z"
  }));
};
FlagSE.displayName = 'FlagSE';
export default withFlagWrapper(FlagSE);
//# sourceMappingURL=index.js.map